import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  FROM_DOMAINS_FILTER_PAIRS,
  FromDomainsFilterChange,
  FromDomainsFilterKey,
  FromDomainsFilterPair,
  FromDomainsFilterState,
} from '@account-users/account/models/FromDomainsFilter';

@Component({
  selector: 'app-from-domains-filter',
  templateUrl: './from-domains-filter.component.html',
  styleUrls: ['./from-domains-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FromDomainsFilterComponent {
  @Input() state: FromDomainsFilterState = {};
  @Output() filterChange = new EventEmitter<FromDomainsFilterChange>();

  readonly pairs: FromDomainsFilterPair[] = FROM_DOMAINS_FILTER_PAIRS;

  isCollapsed = true;

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  isChecked(key: FromDomainsFilterKey, value: boolean): boolean {
    return this.state[key] === value;
  }

  onToggle(key: FromDomainsFilterKey, value: boolean): void {
    this.filterChange.emit({ key, value });
  }
}
